import { Button, Container } from '@cluey/cluey-components';
import classNames from 'classnames';
import { useEffect } from 'react';
import { useHistory } from 'react-router';

import { ReactComponent as CheckIcon } from '../../../assets/images/icon-outline-checked.svg';
import { ContainerLayout } from '../../../common/hub/ContainerLayout';
import { ShadowContainer } from '../../../components/ShadowContainer';
import { PATH_HUB_ENROLMENT_DETAIL } from '../../../util/pagePath';
import { PromoText } from '../PromoText';
import SummerPromoLegalCopy from '../SummerMode/SummerPromoLegalCopy';

interface Props {
  mainHeading: string;
  student: string;
  subject: string;
  enrolmentId: string;
  message: string | Array<string>;
  tracking: string;
  ctaTracking?: string;
  children?: JSX.Element | Array<JSX.Element>;
  cleanUp?(): void;
  promoText?: string;
  showLegalCopy?: boolean;
}

const EnrolmentManagementConfirmed = ({
  mainHeading,
  student,
  subject,
  enrolmentId,
  message,
  tracking,
  ctaTracking,
  cleanUp,
  promoText,
  showLegalCopy,
  children,
}: Props) => {
  const history = useHistory();

  useEffect(() => {
    return () => {
      if (typeof cleanUp === 'function') {
        cleanUp();
      }
    };
    // eslint-disable-next-line
  }, []);

  return (
    <ContainerLayout tracking={tracking}>
      <ShadowContainer className="flex flex-col items-center gap-6 !rounded-3xl bg-white p-6 md:!p-10">
        <div className="flex flex-col items-center gap-2">
          <div className="flex h-[60px] w-[60px] items-center justify-center rounded-full">
            <CheckIcon className="text-white" width={60} height={60} />
          </div>
          <h1 className="text-center font-merriweather text-[32px] font-bold text-grey-600">{mainHeading}</h1>
        </div>
        {children}
        <p className="lh-1-2 mb-5 text-center text-xl">
          {Array.isArray(message) && message.map((info) => info)}
          {!Array.isArray(message) && message}
        </p>
        {promoText && (
          <div className="mb-4">
            <PromoText text={promoText} />
          </div>
        )}
        <Button
          onClick={() => {
            history.push(`${PATH_HUB_ENROLMENT_DETAIL}?token=${enrolmentId}`);
          }}
          size="sm"
          appearance="reverse"
          className={classNames(
            'flex h-10 w-auto items-center justify-center !border text-sm !font-medium tracking-wide text-grey-400 md:text-base',
            {
              [ctaTracking]: ctaTracking !== null,
            }
          )}
        >
          View {student}&apos;s {subject} enrolment
        </Button>

        {showLegalCopy && (
          <Container>
            <SummerPromoLegalCopy />
          </Container>
        )}
      </ShadowContainer>
    </ContainerLayout>
  );
};

export default EnrolmentManagementConfirmed;
